import React from "react";
import { Tabs, Tab, Box, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReactGA from "react-ga4";

export default function MenuTabs({ currentTab, setCurrentTab }) {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const handleChange = (event, newValue) => {
		setCurrentTab(newValue);

		if (newValue === 0) {
			navigate("/");
		} else if (newValue === 1) {
			ReactGA.event({
				category: "link",
				action: "click",
				label: "Go to admin",
			});
			window.location.href =
				(window.location.hostname === "127.0.0.1"
					? "http://127.0.0.1:3001"
					: window.location.hostname === "localhost"
					? "http://localhost:3001"
					: "https://admin.applaby.com") +
				(localStorage.getItem("token")
					? "?session=" + localStorage.getItem("token")
					: "");
		} else if (newValue === 2) {
			navigate("/publish");
		}
	};

	return (
		<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
			<Tabs
				value={currentTab}
				onChange={handleChange}
				textColor="primary"
				indicatorColor="primary"
				sx={{
					minHeight: "30px!important",
					"& .MuiTab-root": {
						minWidth: "75px",
						padding: "5px 10px",
						backgroundColor: "#f5f5f5",
						borderTopLeftRadius: "5px",
						borderTopRightRadius: "5px",
						marginRight: "5px",
						transition: "background-color 0.3s",
						height: "20px",
						maxHeight: "28px",
						minHeight: "28px",
						fontWeight: 600,
					},
					"& .MuiTab-root:hover:not(.Mui-selected)": {
						backgroundColor: "#e0e0e0",
					},
					"& .Mui-selected": {
						backgroundColor: "#43bd98",
						color: "#ffffff!important",
						fontWeight: "bolder",
					},
					"& .MuiButtonBase-root.Mui-selected": {
						border: "1px solid #43bd98!important",
					},
					"& .MuiTabs-indicator": {
						backgroundColor: "#43bd98!important",
					},
				}}
			>
				<Tooltip title={t("creatorTab.tooltip")} arrow>
					<Tab
						id="tab-creator"
						sx={{ fontSize: 10 }}
						label={t("creatorTab.label")}
					/>
				</Tooltip>
				<Tooltip title={t("adminTab.tooltip")} arrow>
					<Tab
						id="tab-admin"
						sx={{ fontSize: 10 }}
						label={t("adminTab.label")}
					/>
				</Tooltip>
				<Tooltip title={t("publishTab.tooltip")} arrow>
					<Tab
						id="tab-publish"
						sx={{ fontSize: 10 }}
						label={t("publishTab.label")}
					/>
				</Tooltip>
			</Tabs>
		</Box>
	);
}
